import React from 'react';
import { useLocation } from 'react-router-dom';

import {
    Box,
    Container,
    Divider,
    Paper,
    Stack,
    Typography,
} from '@mui/material';
import QrCode from '../../../component/common/QrCode';

function Row({ label, value }) {
    return (
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ py: 0.75 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: 'text.secondary' }}>{label}</Typography>
            <Typography sx={{ fontSize: 14, fontWeight: 600 }}>{value || '-'}</Typography>
        </Stack>
    );
}

function QrEventParticipantMyView() {
    const location = useLocation();
    const { uuid, name, affiliation, contactNumber, email, eventName } = location.state || {};

    if (!uuid) {
        return (
            <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography sx={{ color: 'text.secondary' }}>참가자 정보가 없습니다.</Typography>
            </Box>
        );
    }

    const displayName = typeof eventName === 'string' ? eventName.replaceAll('_', ' ') : eventName || '';

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', py: 4 }}>
            <Container maxWidth="xs">
                <Paper elevation={0} sx={{ p: { xs: 3, sm: 4 }, borderRadius: 3, border: '1px solid #e2e8f0' }}>
                    <Stack spacing={0.5} sx={{ mb: 3 }}>
                        <Typography sx={{ fontSize: 20, fontWeight: 800, letterSpacing: '-0.3px', color: 'text.primary' }}>
                            참가자 정보
                        </Typography>
                        <Typography sx={{ fontSize: 13, color: 'text.secondary' }}>{displayName}</Typography>
                    </Stack>

                    <Stack spacing={0}>
                        <Row label="성함" value={name} />
                        <Row label="소속" value={affiliation} />
                        <Row label="연락처" value={contactNumber} />
                        <Row label="이메일" value={email} />
                    </Stack>

                    <Divider sx={{ my: 2.5 }} />

                    <Stack alignItems="center" spacing={1.5}>
                        <Typography sx={{ fontSize: 13, fontWeight: 700, color: 'text.secondary' }}>QR 코드</Typography>
                        <Box
                            sx={{
                                p: 1.5,
                                border: '2px solid #e2e8f0',
                                borderRadius: 1.5,
                                bgcolor: '#fff',
                                display: 'inline-flex',
                            }}
                        >
                            {/* 외부 QR 서비스(api.qrserver.com)로 uuid 를 보내던 것을 로컬 생성으로 교체.
                                참가자 식별자를 외부 사업자에게 넘기지 않고, 그 서비스 장애·사내망
                                차단에도 영향받지 않는다. */}
                            <QrCode value={uuid} size={220} sx={{ borderRadius: 0 }} />
                        </Box>
                        <Typography sx={{ fontSize: 12, color: 'text.disabled' }}>{uuid}</Typography>
                    </Stack>
                </Paper>
            </Container>
        </Box>
    );
}

export default QrEventParticipantMyView;
